import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface ApplyWithProfileResponse extends BackendResponse {
  idCandidate: number;
  typeRelated: number;
  idRelated: number;
  idRecruitmentCandidate: number | null;
  idVacancyCandidate: number | null;
  idStatus: number;
  statusCaption: string;
}
export interface ApplyWithProfileParameters extends NextApiParams {
  /**
   * typeRelated: number;
   * idRelated: number;
   * publicApplicantListIsOkay: boolean;
   * triggerSystemEvent: boolean;
   * applicationText: string | null;
   * attachment: any | null;
   */
  formData: FormData;
}

export const applyWithProfile = withNextApi<
  ApplyWithProfileResponse,
  ApplyWithProfileParameters
>("/cvp/CvpApplyWithProfile");
